import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: 20
  },
  filtersContainer: {
    display: 'grid',
    gridTemplateColumns: '5fr 1fr',
    columnGap: 20,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }
}))

export default useStyles
